module.exports = __webpack_public_path__ + "img/mark_star_8_icon.02da1dc7.png";